<template>
  <div>
    <img alt="" class="bg" src="../../assets/photo/bg.png">
    <img alt="" class="logo" src="../../assets/photo/logo5.png">
    <div class="bgcontent">
      <img alt="" class="bg2" src="../../assets/photo/bg2.png">
      <img alt="" class="wzroast" src="../../assets/photo/web_1_wz.png">
    </div>
    <img alt="" class="sm" src="../../assets/photo/sm.png">
    <router-link to="/roast/addroast">
      <img alt="" class="buttonroast" src="../../assets/photo/button.png">
    </router-link>
  </div>
</template>
<script>
export default {
  name: "company",
  components: {},
  mounted() {
    document.title = "一个树洞";
  }
}
</script>
<style>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.bgcontent {
  position: relative;
  width: 1440px;
  height: 670px;
  left: calc(50vw - 720px);
  top: calc(50vh - 335px);
}

.bg2 {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}

.buttonroast {
  position: absolute;
  width: 246px;
  top: 70%;
  left: calc(50vw - 123px);
  z-index: 1;
}

.logo {
  position: absolute;
  top: 70px;
  left: 70px;
  z-index: 2;
}

.wzroast {
  position: absolute;
  top: 10%;
  left: calc(50% - 207px);
  z-index: 2;
  width: 415px;
  height: 460px;
}

.sm {
  position: absolute;
  top: 90%;
  left: calc(50% - 135px);
  z-index: 2;
}

</style>
